import { useCallback, useState } from "react";
import { ApiError, postApi } from "../../../../utils/api.ts";
import { accessToken } from "../../../../utils/auth.ts";
import { API_OFFBOARDING_QUESTIONNAIRE_SUBMIT } from "../../../../../config/Endpoints.js";
import { useSqeLabs } from "../../../../hooks/use-sqe-labs.ts";
import { SQE_OFFBOARDING_URL } from "../api/sqe-offboarding-api.ts";
import {
    OffboardingQuestionnaireSubmitPayload,
    OffboardingSectionType,
} from "../schemas/index.ts";

interface SubmitArgs {
    offboardingId: number;
    sectionType: OffboardingSectionType;
    answers: { questionId: number; answer: string }[];
    personalEmail?: string;
}

export function useOffboardingQuestionnaireSubmit() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const isSqe = useSqeLabs();

    const submit = useCallback(
        async ({
            offboardingId,
            sectionType,
            answers,
            personalEmail,
        }: SubmitArgs) => {
        setLoading(true);
        setError(null);

        const payload: OffboardingQuestionnaireSubmitPayload = {
            offboardingId,
            sectionType,
            answers,
            ...(personalEmail != null && personalEmail.trim() !== ""
                ? { personalEmail: personalEmail.trim() }
                : {}),
        };

        try {
            await postApi(
                isSqe ? `${SQE_OFFBOARDING_URL}/questionnaire/submit` : API_OFFBOARDING_QUESTIONNAIRE_SUBMIT,
                accessToken(),
                payload as unknown as Record<string, unknown>,
            );
            return true as const;
        } catch (e) {
            const msg =
                e instanceof ApiError
                    ? e.message
                    : "Failed to submit questionnaire.";
            setError(msg);
            return msg;
        } finally {
            setLoading(false);
        }
    }, [isSqe]);

    return { submit, loading, error };
}
